import { render, staticRenderFns } from "./ExpendingOption.vue?vue&type=template&id=61c0e45a&scoped=true&"
import script from "./ExpendingOption.vue?vue&type=script&lang=js&"
export * from "./ExpendingOption.vue?vue&type=script&lang=js&"
import style0 from "./ExpendingOption.vue?vue&type=style&index=0&id=61c0e45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0e45a",
  null
  
)

export default component.exports